module.exports = __webpack_public_path__ + "static/media/iStock-1126856471.fd59f77e.jpg";